<template>
  <div>
    <div class="primary-background py-3">
      <div class="container">
        <div class="d-flex justify-content-end">
          <ol class="breadcrumb text-align-right">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li v-if="!loadingProgram" class="breadcrumb-item">
              <router-link :to="{ name: 'seminars' }">
                {{ loadingProgram ? '...' : 'Seminars' }}
              </router-link>
            </li>
            <li class="breadcrumb-item active text-truncate" style="max-width: 280px;">
              {{ loadingProgram ? '...' : programDetails.name }}
            </li>
          </ol>
        </div>
      </div>
    </div>

    <custom-loader v-if="loadingProgram" />
    <div v-else>
      <div class="primary-background mb-4">
        <div class="container">
          <div class="d-flex justify-content-end align-items-center">
            <!-- <div class="flex-grow-1">
              <h1 class="lyon-display-medium-32">Colloquia & Seminars Details</h1>
            </div> -->
            <div v-if="canEditCms">
              <!-- <i
              class="fa fa-toggle-on edit-icon"
              v-b-tooltip.hover title="Seminars Apply Now Button Settings"
              @click="openApplyNowModal"
              v-if="!programDetails.is_past"
            /> -->
              <i
                v-b-tooltip.hover
                v-b-modal="'seminarSettingsModal'" class="fa fa-cog edit-icon" title="Quick Edit"
              />
              <a :href="fetchLegacyUrl(`/seminars/${programDetails.id}/edit`)">
                <i v-b-tooltip.hover class="fa fa-edit edit-icon" title="Full Edit" />
              </a>
              <i
                v-b-tooltip.hover
                class="fas fa-trash edit-icon"
                title="Delete"
                @click="deleteSemester(programDetails.id)"
              />
            </div>
            <div ref="parentQuickLinkContainer" class="ml-3">
              <custom-quick-link-section
                :quick-link-list="quickLinkList"
                :show-admin-tools="true"
                :event-type="'seminars'"
                :event-quick-link="programDetails.quick_links"
              />
            </div>
          </div>
          <b-alert v-if="programDetails.is_seminar_registration" show variant="info">
            <span class="lyon-display-medium-18">You have registered for this event.</span>
          </b-alert>
          <b-alert v-if="programDetails.registrant_information && programDetails.is_seminar_registration" show variant="info">
            <span v-html="programDetails.registrant_information" />
          </b-alert>
          <div class="row justify-content-between">
            <div class="col-lg-7 col-xl-4 mb-4">
              <div class="custom-featured-image">
                <img :src="fetchImage(programDetails.image_url, 400, 300)" onerror="this.onerror=null;this.src='/img/SLMath/SLMath_default.png';">
                <span class="text-muted regular-12">{{ programDetails.image_caption_name }}</span>
              </div>
            </div>

            <div class="col-lg-5 col-xl-7 my-auto">
              <div v-if="programDetails.status" :class="eventStatusType(programDetails.status)">
                <span class="regular-14 typo-color-white text-uppercase">
                  {{ programDetails.status }}
                </span>
              </div>
              <div class="text-muted regular-12 mb-2">
                <span>{{ moment(programDetails.from, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY') }}</span>
                <span> - </span>
                <span>{{ moment(programDetails.to, 'YYYY-MM-DD HH:mm:ss').format('MMMM Do, YYYY') }}</span>
              </div>
              <div class="regular-32 mb-2">
                <i
                  v-if="!programDetails.visible_on_public_site"
                  v-b-tooltip.hover.top
                  title="SLMath Only"
                  class="fas fa-lock"
                />
                {{ programDetails.name }}
              </div>
              <!-- <div class="medium-14 typo-color-blue mb-2">
                <i class="fas fa-envelope"></i>
                <a :href="`mailto:${programDetails.contact}`"> {{programDetails.contact}}</a>
              </div> -->
              <div v-if="programDetails.parent_program.length > 0" class="row mb-3 mt-4">
                <div class="col-md-4">
                  <span class="text-muted regular-16">Parent Program</span>
                </div>
                <div class="col-md-8">
                  <div
                    v-for="(parentProgram, index) in programDetails.parent_program"
                    :key="index"
                    class="mb-1"
                  >
                    <router-link :to="{ name: 'programs-details', params: { id: parentProgram.id }}">
                      <span class="regular-16 typo-color-blue">{{ parentProgram.name }}</span>
                    </router-link>
                  </div>
                </div>
              </div>
              <div v-if="checkNullAndEmptyValues(programDetails.event_location)" class="row mb-3">
                <div class="col-md-4">
                  <span class="text-muted regular-16">Location</span>
                </div>
                <div class="col-md-8">
                  <div class="regular-16">{{ programDetails.event_location }}</div>
                </div>
              </div>
              <div v-if="canEditCms">
                <!-- <div class="row mb-3">
                  <div class="col-md-4">
                    <span class="text-muted regular-16">Status</span>
                  </div>
                  <div class="col-md-8">
                    <div class="regular-16">{{programDetails.status}}</div>
                  </div>
                </div> -->
                <div class="row mb-3">
                  <div class="col-md-4">
                    <span class="text-muted regular-16">Categories</span>
                  </div>
                  <div class="col-md-8">
                    <span v-for="(category, index) in programDetails.categories" :key="index" class="regular-16">
                      <span v-if="index < programDetails.categories.length - 1">{{ category.name }}, </span>
                      <span v-else>{{ category.name }}</span>
                    </span>
                  </div>
                </div>
              </div>
              <!-- <div class="mt-3" v-if="!programDetails.is_past && isAuthenticated && applyNowButtonVisible">
                <a
                  :href="applyNowButtonVisible.button_url"
                  v-if="applyNowButtonVisible.is_visible && applyNowButtonVisible.button_text"
                >
                  <button class="btn btn-primary btn-md">
                    {{ applyNowButtonVisible.button_text }}
                  </button>
                </a>
              </div> -->
              <div class="mt-3">
                <!-- <span v-if="programDetails.secure_registration && !programDetails.is_seminar_registration && !programDetails.registration_date_expired">
                  <router-link
                    :to="{ name: 'seminar-registration', params: { id: programDetails.id }, query: { secure: programDetails.secure_registration_token }}"
                  >
                    <button class="btn btn-primary btn-md mb-3">
                      REGISTER
                    </button>
                  </router-link>
                </span> -->
                <span
                  v-if="!programDetails.secure_registration && !programDetails.is_seminar_registration && !programDetails.registration_date_expired"
                >
                  <router-link
                    :to="{ name: 'seminar-registration', params: { id: programDetails.id }}"
                  >
                    <button class="btn btn-primary btn-md mb-3">
                      REGISTER
                    </button>
                  </router-link>
                </span>
                <b-alert v-else-if="programDetails.registration_date_expired" show variant="info">
                  <span class="lyon-display-medium-18">Registration deadline has passed.</span>
                </b-alert>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <tabs-section
          v-if="!loadingProgram"
          :datas="programDetails"
        />
      </div>
      <b-modal
        id="seminarsApplyNowButtonSettingsModal"
        ref="seminarsApplyNowButtonSettingsModal"
        size="lg"
        title="Seminars Apply Now Button Settings"
        centered
        hide-footer
      >
        <detail-apply-button-form
          :type="'seminars'"
          :ref-id="'seminarsApplyNowButtonSettingsModal'"
          :modal-data="applyNowButtonModal"
        />
      </b-modal>
      <b-modal
        id="seminarSettingsModal"
        ref="seminarSettingsModal"
        size="xl"
        title="Seminar Quick Edit"
        centered
        hide-footer
        no-enforce-focus
        no-close-on-backdrop
        no-close-on-esc
      >
        <colloquia-seminar-edit-form
          :modal-data="programDataForm"
          :categories-listing="categoriesListing"
          @updateSeminarData="updateSeminarData"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import TabsSection from "./TabsSection.vue"
import mixin from "@/utils/mixin.js"
import CustomLoader from "@/components/CommonPages/CustomLoader.vue"
import { mapGetters } from "vuex"
import DetailApplyButtonForm from "@/components/CommonPages/DetailApplyButtonForm/DetailApplyButtonForm.vue"
import ColloquiaSeminarEditForm from "./ColloquiaSeminarEditForm.vue"
import CustomQuickLinkSection from "@/components/QuickLink/CustomQuickLinkSection.vue"

export default {
	name: "CurrentFeaturedColloquiaSeminarsDetailsSection",
	components: { TabsSection, CustomLoader, DetailApplyButtonForm, ColloquiaSeminarEditForm, CustomQuickLinkSection },
	mixins: [mixin],
	props: ["colloquiaSeminarsType"],
	metaInfo: {
		title: "Seminars Detail",
	},
	data() {
		return {
			programDetails: null,
			loadingProgram: true,
			applyNowButtonModal: null,
			applyNowButtonVisible: null,
			programDataForm: null,
			categoriesListing: [],
			quickLinkList: [],
		}
	},
	computed: {
		...mapGetters(["canEditCms", "isAuthenticated"]),
	},
	watch: {
		isAuthenticated() {
			this.loadColloquiaSeminarsDetails()
		},
	},
	async created() {
		await this.loadColloquiaSeminarsDetails()
		// if(this.isAuthenticated) {
		//   await this.applyNowRights()
		// }
		await this.loadCategoriesListingData()
	},
	// mounted() {
	//   let that = this
	//   this.$root.$on('seminarsApplyNowButtonSettingsModal', function(){
	//     that.$refs.seminarsApplyNowButtonSettingsModal.hide()
	//     that.applyNowRights()
	//   })
	// },
	methods: {
		updateSeminarData(isHide) {
			if (isHide) {
				this.$refs.seminarSettingsModal.hide()
			} else {
				this.$refs.seminarSettingsModal.hide()
				this.loadColloquiaSeminarsDetails()
			}
		},
		loadColloquiaSeminarsDetails() {
			this.loadingProgram = true
			this.$http
				.get(`${process.env.VUE_APP_API_URL}/seminars/${this.$route.params.id}.json`, { validateStatus: () => true })
				.then((res) => {
					if (res.status === 404) {
						this.$router.replace({ name: "home" })
					} else if (!this.checkValidateStatus(res.status)) {
						this.programDetails = res.data
						this.programDataForm = { ...res.data }
						this.loadDescScript(res.data.abstract)
						if (res.data.quick_link_hdr_id !== null) this.quickLinkList = res.data.menu
						this.loadingProgram = false
					}
				})
		},
		loadCategoriesListingData() {
			this.$http.get(`${process.env.VUE_APP_API_URL}/workshops/workshop_categories`).then((res) => {
				if (res !== null) {
					this.categoriesListing = res.data
					this.categoriesListing = this.categoriesListing?.map((item) => ({ value: item.id, text: item.name }))
				}
			})
		},
		async openApplyNowModal() {
			await this.applyNowRights()
			this.$refs.seminarsApplyNowButtonSettingsModal.show()
		},
		async applyNowRights() {
			await this.$http
				.get(`${process.env.VUE_APP_API_URL}/program_admin_toggle_rights/show_toggle`, {
					params: {
						page_name: "seminars",
					},
				})
				.then((res) => {
					this.applyNowButtonVisible = { ...res.data }
					this.applyNowButtonModal = res.data
				})
		},
		deleteSemester(id) {
			if (confirm("Do you really want to delete?")) {
				this.$http.delete(`${process.env.VUE_APP_API_URL}/seminars/${id}`).then((res) => {
					if (res !== undefined) {
						if (res.data.error !== undefined) {
							this.$toasted.global.error(res.data.error)
						} else {
							this.$toasted.global.success("Deleted Successfully")
							this.$router.push({ name: "seminars" })
						}
					}
				})
			}
		},
	},
}
</script>
